import { Attributes, Misc, Rules, Validation } from '@singularsystems/neo-core';
import TemporalEntity from '../TemporalEntity';

export default class IssuerContact extends TemporalEntity {

    constructor() {
        super();
        this.makeObservable();
    }

    public issuerContactId: number = 0;

    public issuerId: number = 0;

    @Rules.Required()
    @Attributes.Serialisation(Misc.SerialiseType.NotNull)
    public contactId: number | null = null;

    @Attributes.NoTracking(Misc.SerialiseType.FullOnly)
    public contactName: string | null = null;

    @Rules.Required()
    public contactTypeId: number | null = null;

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        if (this.isNew) {
            return "New issuer contact";
        } else {
            return "Issuer Contact";
        }
    }
}